import { TelemetryService, TrackingService } from "@common/_services";
import qs from "qs";
import * as React from "react";
import { Route } from "react-router-dom";

export default class PublicRoute extends Route {
    componentDidMount() {
        if (!this.props.location) return;
        const qString = qs.parse(this.props.location.search, {
            ignoreQueryPrefix: true,
        });

        const trackingInfo = {
            utm_campaign: qString.utm_campaign as any,
            utm_content: qString.utm_content as any,
            utm_medium: qString.utm_medium as any,
            utm_term: qString.utm_term as any,
            utm_source: qString.utm_source as any,
            sponsor: qString.sponsor as any,
        };

        TrackingService.setTrackingInfo(trackingInfo);

        let url = this.props.location.pathname;
        if (!!this.props.location.search) {
            url += this.props.location.search;
        }

        TelemetryService.trackRoute(this.props.location.pathname, url, null);
    }

    render() {
        return <Route {...this.props} />;
    }

    componentDidUpdate(prevProps) {
        if (!this.props.location) return;

        // if we are not changing then skip
        if (
            prevProps &&
            prevProps.location &&
            prevProps.location.pathname === this.props.location.pathname &&
            prevProps.location.search === this.props.location.search
        ) {
            return;
        }

        let url = this.props.location.pathname;
        if (!!this.props.location.search) {
            url += this.props.location.search;
        }

        TelemetryService.trackRoute(this.props.location.pathname, url, null);
    }
}
